import { API } from '../../../../API/config'

export const inviteForSubscriptionOffer = (email) =>
  API.post('/invitations', {
    templateType: 'SUBSCRIPTION_INVITATION_JUL_05',
    userEmail: email,
  })
    .then(() => true)
    .catch(() => false)

export const deleteSubscriptionInvite = (id) =>
  API.delete(`/invitation/SUBSCRIPTION_INVITATION_JUL_05/${id}`)
    .then(() => true)
    .catch(() => false)
